module.exports = __webpack_public_path__ + "account/img/78.ffff64f2.png";